import axios from "axios";

const iaxios = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

export default iaxios